import * as React from "react";
import type { SVGProps } from "react";
const SvgZoomOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M13.962 16.296a6.7 6.7 0 0 1-3.462.954 6.73 6.73 0 0 1-4.773-1.977A6.73 6.73 0 0 1 3.75 10.5c0-1.864.755-3.551 1.977-4.773A6.73 6.73 0 0 1 10.5 3.75a6.73 6.73 0 0 1 4.774 1.977A6.74 6.74 0 0 1 17.25 10.5a6.7 6.7 0 0 1-.922 3.407c-.516.882-.433 1.988.29 2.711l3.854 3.853M7.5 10.5h6"
    />
  </svg>
);
export default SvgZoomOut;
